import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getLocalStore, setLocalStore } from 'utils/functions'
import { TChatListData, TChatState, TGetChatMessage } from '../types'

const CHAT_STATE_LOCAL = 'chat-state'
const CHAT_LIST_LOCAL = 'chat-list'

const updateChatListToLocal = (chatList: TChatListData[]) =>
 setLocalStore(CHAT_LIST_LOCAL, `${JSON.stringify(chatList)}`)

const initialStorageState: TChatState | null = getLocalStore(CHAT_STATE_LOCAL)
 ? (JSON.parse(`${getLocalStore(CHAT_STATE_LOCAL)}`) as TChatState)
 : null

const initialChatList: TChatListData[] = getLocalStore(CHAT_LIST_LOCAL)
 ? (JSON.parse(`${getLocalStore(CHAT_LIST_LOCAL)}`) as TChatListData[])
 : []

const initialState: TChatState = {
 chatList: initialChatList || [],
 minimized: false,
 show: false,
 screen: null as any,
 currentGroupId: null,
 headerCollapsed: true,
 showInviteModal: false,
 replyChat: null,
 property: null,
 currentProId: null,
}

const ChatSlice = createSlice({
 name: 'ChatNew',
 initialState: initialStorageState ?? initialState,
 reducers: {
  showChatModal: (state, { payload }: PayloadAction<boolean>) => {
   state.show = payload
   state.screen = payload ? 'chatHistory' : (null as any)
  },
  toggleMinimize: (state) => {
   state.minimized = !state.minimized
  },
  updateChatList: (state, { payload }: PayloadAction<TChatListData>) => {
   const existingIndex = state.chatList?.findIndex((v) => v.id === payload.id)

   if (existingIndex !== undefined && existingIndex !== -1) {
    if (state.chatList) {
     const currentItem = state.chatList[existingIndex]
     state.chatList[existingIndex] = {
      ...currentItem,
      ...payload,
     }
     updateChatListToLocal(state.chatList)
    }
   } else {
    const listData: TChatListData = {
     unReadCount: 0,
     minimized: payload.minimized ?? false,
     ...payload,
    }
    const chatList: TChatListData[] = [listData, ...(state.chatList || [])]
    state.chatList = chatList
    state.show = false
    updateChatListToLocal(chatList)
   }
  },
  updateChatListPosition: (
   state,
   { payload }: PayloadAction<TChatListData>,
  ) => {
   const index =
    state.chatList?.findIndex((v) => v.leadId === payload.leadId) || 0
   const chatList: TChatListData[] = [...(state.chatList || [])]
   if (index !== -1) {
    chatList?.splice(index, 1)
    chatList?.unshift(payload)
   }
   state.chatList = chatList
   updateChatListToLocal(chatList)
  },
  updateChatListById: (
   state,
   {
    payload,
   }: PayloadAction<{
    id: any
    data: Partial<TChatListData>
   }>,
  ) => {
   const chatList: TChatListData[] =
    state.chatList?.map((v) => {
     if (v.id === payload.id) {
      return {
       ...v,
       ...payload.data,
      }
     }
     return v
    }) || []
   state.chatList = chatList
   updateChatListToLocal(chatList)
  },
  removeFromChatList: (state, { payload }: PayloadAction<{ id: any }>) => {
   const chatList: TChatListData[] =
    state.chatList?.filter((v) => v.id !== payload?.id) || []
   state.chatList = chatList
   updateChatListToLocal(chatList)
  },
  clearChatList: (state) => {
   state.chatList = []
   updateChatListToLocal([])
  },
  toggleChat: (state) => {
   state.show = !state.show
  },
  toggleHeaderCollps: (state) => {
   state.headerCollapsed = !state.headerCollapsed
  },
  updateState: (state, { payload }: PayloadAction<TChatState>) => {
   const chatState: TChatState = {
    ...state,
    ...payload,
    minimized: false,
   }
   delete chatState.showInviteModal
   return chatState
  },
  resetChatState: (state) => {
   state.show = false
  },
  toggleModalInvite: (state, { payload = true }: PayloadAction<boolean>) => {
   state.showInviteModal = payload
  },
  setReplyMsg: (state, { payload }: PayloadAction<TGetChatMessage | null>) => {
   state.replyChat = payload
  },
 },
})

export const {
 showChatModal,
 updateChatListPosition,
 updateChatListById,
 removeFromChatList,
 clearChatList,
 updateChatList,
 toggleChat,
 updateState,
 toggleHeaderCollps,
 toggleModalInvite,
 setReplyMsg,
 resetChatState,
 toggleMinimize,
} = ChatSlice.actions

export default ChatSlice.reducer
